import { c as _c } from "react/compiler-runtime";
export const SkullIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <i className="material-symbols-skull-outline min-w-[20px] min-h-[20px] m-[2px] bg-(--mui-palette-error-main)" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};